import React from "react";
import UpcomingOrdersOverview from "@widgets/pos/upcoming/UpcomingOrdersOverview";

const PosUpcomingOrders = () => {
    return <UpcomingOrdersOverview/>;
};

export default PosUpcomingOrders;